import { FC } from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import { stringToRichText } from '@belong/contentful/helpers';
import { BUTTON_VARIANTS } from '@belong/themes';
import { IControlSectionAction } from '@belong/types/sectionInfo';
import { SectionWrapper } from '@belong/ui-components/components/styles/Section/Section.styles';
import SectionInfo from '../sectionInfo/view';
import error from './content/error.json';

const { HEADING, BODY } = error;

interface ISearchGenericErrorProps {
  onPrimaryButtonAction: IControlSectionAction;
}

// Generic error component for search
export const SearchGenericError: FC<ISearchGenericErrorProps> = ({ onPrimaryButtonAction }) => {
  return (
    <SectionWrapper hasPaddingBottom hasPaddingTop>
      <SectionInfo
        isPadded={false}
        headingContent={stringToRichText(HEADING, BLOCKS.HEADING_2)}
        bodyContent={stringToRichText(BODY)}
        primaryAction={{
          variant: BUTTON_VARIANTS.PRIMARY,
          label: 'Retry search'
        }}
        primaryControlAction={onPrimaryButtonAction}
        bodyAlignment="center"
        buttonAlignment="center"
        contentType="sectionInfo"
        identifier="searchGenericError"
        autoFocusHeading
      />
    </SectionWrapper>
  );
};
